import axios, { getServerErrorMessage } from '../utils/axios'
import * as c from '../constants/TabConstants'
import {
  ARTYPE_ANCILLARYMATERIALS,
  ARTYPE_EXCEPTIONTESTING,
  ARTYPE_NONSTOCKEDSSD,
  ARTYPE_OFFCYCLETESTING,
  ARTYPE_ORDERSAFTERDEADLINE,
  ARTYPE_RESHIPMENTS,
} from '../constants/ApprovalRequestConstants'

export const fetchApprovalTabCounts = () => (dispatch, getState) => {
  const educationPeriodCd = getState().settingsEducationPeriod.current

  dispatch({ type: c.FETCH_APPROVALS_TAB_COUNTS_PENDING })
  return axios
    .get(`${Config.API_URL}/orders/pending-approval-counts`)
    .then(res => dispatch({ type: c.FETCH_APPROVALS_TAB_COUNTS_FULFILLED, payload: res.data }))
    .catch(err =>
      dispatch({ type: c.FETCH_APPROVALS_TAB_COUNTS_REJECTED, payload: getServerErrorMessage(err) })
    )
}

export const updateApprovalTabCounts = (arType, newCount) => (dispatch, getState) => {
  const { approvalTabCounts } = getState()
  switch (arType) {
    case ARTYPE_ANCILLARYMATERIALS:
      approvalTabCounts.ancillaryMaterials = newCount
      break
    case ARTYPE_NONSTOCKEDSSD:
      approvalTabCounts.nonStockedSSDs = newCount
      break
    case ARTYPE_OFFCYCLETESTING:
      approvalTabCounts.offCycle = newCount
      break
    case ARTYPE_EXCEPTIONTESTING:
      approvalTabCounts.exceptionTests = newCount
      break
    case ARTYPE_ORDERSAFTERDEADLINE:
      approvalTabCounts.orderedAfterDeadlines = newCount
      break
    case ARTYPE_RESHIPMENTS:
      approvalTabCounts.reshipments = newCount
      break
    default:
      return
  }
  dispatch({ type: c.UPDATE_APPROVALS_TAB_COUNTS_PENDING })
  dispatch({ type: c.UPDATE_APPROVALS_TAB_COUNTS_FULFILLED, payload: approvalTabCounts })
}
